import {
  type PriceInput,
  priceForWorkspace,
  priceInputSchema,
  resolvePriceInput,
} from "../../domain/contracts/live-workspace";

export type ProductSetPrices = Record<string, PriceInput>;

/** Apply only the explicitly reviewed IDs; existing and hidden rows retain their rules. */
export function editProductSetPrices(
  current: ProductSetPrices,
  ids: string[],
  price: PriceInput,
): ProductSetPrices {
  return {
    ...current,
    ...Object.fromEntries(ids.map((id) => [id, { ...price }])),
  };
}

export function productSetItems(ids: string[], prices: ProductSetPrices) {
  return ids.map((variantId) => {
    const price = prices[variantId];
    if (!price) throw new Error("INVALID_PRICE");
    return { variantId, price: { ...price } };
  });
}

export function productSetEstimate(base: number, price: PriceInput) {
  if (!priceInputSchema.safeParse(price).success)
    throw new Error("INVALID_PRICE");
  const discount = resolvePriceInput(base, price);
  if (price.mode === "inherit") return null;
  return priceForWorkspace(base, discount, {
    listDiscountPercent: null,
    listDiscountFixedLak: null,
    freeShipping: false,
    shippingFeeLak: null,
    options: [],
  });
}
